import { render } from "./impajust.vue?vue&type=template&id=20f8af05"
import script from "./impajust.vue?vue&type=script&lang=js"
export * from "./impajust.vue?vue&type=script&lang=js"

import "./impajust.vue?vue&type=style&index=0&id=20f8af05&lang=css"

import exportComponent from "D:\\work\\work\\project\\intelegent\\ips\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__